import { Controller } from "stimulus"
import { getCookie, setCookie } from "../../frontend/js/cookies"

export default class extends Controller {
  // static values = {
  //   highContrast: Boolean,
  // }
  
  // highContrastToggle() {
  //   let highContrast = getCookie('highContrast');
  //   if (highContrast == "true") {
  //     this.setDefault();
  //     this.highContrast = false;
  //   } else {
  //     this.setHighContrast();
  //     this.highContrast = true;
  //   }
  //   setCookie('highContrast', this.highContrast)
  // }
  
  // setHighContrast() {
  //   this.rootElement.classList.remove('default');
  //   this.rootElement.classList.add('highContrast');
  // }

  // setDefault() {
  //   this.rootElement.classList.remove('highContrast');
  //   this.rootElement.classList.add('default');
  // }
  
  largeFontSize() {
    let newFontSize = (this.fontSize*1.3) + 'px';
    setCookie('fontSize', newFontSize)
    this.rootElement.style.fontSize = newFontSize;
  }
  
  mediumFontSize() {
    let newFontSize = (this.fontSize*1.2) + 'px';
    setCookie('fontSize', newFontSize)
    this.rootElement.style.fontSize = newFontSize;
  }
  
  standardFontSize() {
    let newFontSize = this.fontSize + 'px';
    setCookie('fontSize', newFontSize)
    this.rootElement.style.fontSize = newFontSize;
  }
  
  initialize() {
    this.fontSize = 16;
    this.rootElement = document.getElementById('rootHtml');
    let fontSize = getCookie('fontSize')
    if (fontSize) {
      setCookie('fontSize', fontSize)
      this.rootElement.style.fontSize = fontSize
    }
    // let highContrast = getCookie('highContrast')
    // if (highContrast == "true") { 
    //   this.setHighContrast();
    // } else {
    //   this.setDefault();
    // }
  }
  
  
}
